// src/Components/BankingReconciliation/components/StatTiles.jsx
import React from "react";
import Styles from "./StatTiles.module.css";
import { formatInr } from "../../utils/reconFormat";

const StatTiles = ({ portfolio }) => {
  const tiles = [
    { key: "scheduled", accent: "#ef7f39", accent2: "#f6a86b", label: "TOTAL SCHEDULED", value: formatInr(portfolio.scheduled), unit: "MWh", sub: `Across ${portfolio.totalRequisitions} requisitions` },
    { key: "actual", accent: "#2e6b6b", accent2: "#4fa0a0", label: "TOTAL ACTUAL", value: formatInr(portfolio.actual), unit: "MWh", sub: `${portfolio.drawnPct}% of scheduled` },
    { key: "drawn", accent: "#7b5ea7", accent2: "#a98fce", label: "TOTAL DRAWN", value: formatInr(portfolio.totalDrawn), unit: "MWh", sub: `${portfolio.drawnPct}% utilised` },
    { key: "reqs", accent: "#3f9d6d", accent2: "#6fc79a", label: "REQUISITIONS", value: portfolio.totalRequisitions, unit: "active", sub: `${portfolio.needAttention} need attention` },
  ];

  return (
    <div className={Styles.grid}>
      {tiles.map((t) => (
        <div key={t.key} className={Styles.tile} style={{ "--accent": t.accent, "--accent2": t.accent2 }}>
          <div className={Styles.head}>
            <span className={Styles.dot} />
            <span className={Styles.label}>{t.label}</span>
          </div>
          <div className={Styles.value}>
            {t.value} <span className={Styles.unit}>{t.unit}</span>
          </div>
          <div className={Styles.sub}>{t.sub}</div>
        </div>
      ))}
    </div>
  );
};

export default StatTiles;
